<template>
  <div class="CardTable">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CardTable',
  data() {
    return {
    }
  }
}
</script>

<style scoped>
.CardTable {
  background: var(--white);
  border-radius: 4px;
  padding: 4px 0;
}

.CardTable .card-item {
  font-size: var(--content-font-size);
  line-height: var(--content-line-height);
  display: inline-flex;
  width: 100%;
  padding: 12px 16px;
}

.CardTable .card-item:not(:first-child) {
  border-top: 1px solid var(--gray30);
}

.CardTable .card-item .label {
  padding-right: 16px;
  width: 132px; /* label width */
  color: var(--gray600);
  flex-shrink: 0;
}

.CardTable .card-item .value {
  width: calc(100% - 132px); /* value width = (100% - label width) */
}

.CardTable .card-item ::v-deep .el-form-item {
  display: inline-flex;
  width: 100%;
}

.CardTable .card-item ::v-deep .el-form-item:first-child {
  margin: 0;
}

.CardTable .card-item ::v-deep .el-form-item:not(first-child) {
  margin: 16px 0 0;
}

.CardTable .card-item ::v-deep .el-form-item__label {
  font-size: var(--content-font-size);
  line-height: var(--content-line-height);
  color: var(--gray600);
  width: 132px; /* label width */
  text-align: left;
  flex-shrink: 0;
  margin-bottom: 0;
  line-height: 40px;
}

.CardTable .card-item ::v-deep .el-form-item__content {
  width: calc(100% - 132px); /* value width = (100% - label width) */
  font-size: var(--content-font-size);
  line-height: 40px;
}

.CardTable .card-item ::v-deep .el-radio__label,
.CardTable .card-item ::v-deep .el-radio__input,
.CardTable .card-item ::v-deep .el-checkbox__label,
.CardTable .card-item ::v-deep .el-checkbox__input {
  font-size: var(--content-font-size);
  line-height: var(--content-line-height);
}

/* remove el-form-item required mark */
.CardTable .card-item ::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  content: none;
}

/* mark for required form */
.CardTable .card-item ::v-deep .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:after,
.CardTable .card-item ::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after {
  content: '*';
  color: #F56C6C;
  margin-left: 4px;
}
</style>